import { Check } from 'lucide-react';
import { Progress } from '../core/Progress';
import { useWizard } from '../../context/WizardContext';
import { STEP_LABELS, WIZARD_STEPS } from '../../types/wizard';
import { cn } from '../../lib/utils';

export function WizardProgressBar() {
  const { currentStepIndex, totalSteps, currentStep, goToStep } = useWizard();
  const progressValue = (currentStepIndex / (totalSteps - 1)) * 100;

  return (
    <div className="w-full space-y-3">
      {/* Label row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-brand-600 text-white text-[10px] font-bold">
            {currentStepIndex + 1}
          </span>
          <span className="text-sm font-semibold text-white">{STEP_LABELS[currentStep]}</span>
        </div>
        <span className="text-xs text-slate-400 font-medium">
          {currentStepIndex + 1} / {totalSteps}
        </span>
      </div>

      {/* Progress bar */}
      <Progress value={progressValue} />

      {/* Step dots — desktop only */}
      <div className="hidden md:flex items-center justify-between gap-1 pt-0.5">
        {WIZARD_STEPS.map((step, idx) => {
          const isCompleted = idx < currentStepIndex;
          const isCurrent = idx === currentStepIndex;
          const canNavigate = idx < currentStepIndex;
          return (
            <button
              key={step}
              type="button"
              onClick={() => canNavigate && goToStep(step)}
              className={cn(
                'flex flex-col items-center gap-1 group focus:outline-none',
                canNavigate ? 'cursor-pointer' : 'cursor-default'
              )}
              title={STEP_LABELS[step]}
              disabled={!canNavigate}
            >
              <div
                className={cn(
                  'flex items-center justify-center rounded-full transition-all duration-300',
                  isCompleted && 'h-4 w-4 bg-violet-500 text-white',
                  isCurrent && 'h-4 w-4 bg-violet-500 shadow-glow',
                  !isCompleted && !isCurrent && 'h-2 w-2 bg-slate-600 mt-1'
                )}
              >
                {isCompleted && <Check className="h-2.5 w-2.5" strokeWidth={3} />}
                {isCurrent && <div className="h-1.5 w-1.5 rounded-full bg-white" />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
